import { render, staticRenderFns } from "./EditPasswordProfile.vue?vue&type=template&id=2f92f336&lang=pug&"
import script from "./EditPasswordProfile.vue?vue&type=script&lang=ts&"
export * from "./EditPasswordProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports